<template>
  <div class="date-time-field">
    <div id="DateTime">
      <b v-if="!isDesktop()">{{label}}</b>
      <div class="cal-input-fields">
        <div>
          <input :type="inputType" style="min-width: 35px"
                placeholder="YYYY" v-model="date[0]"
                @keypress="keyHandling($event, 'Year')"
                @blur="calculateDate()" />-
          <input id="StartMonth" :type="inputType"
                placeholder="MM" v-model="date[1]"
                @keypress="keyHandling($event, 'Month')" @blur="calculateDate(0)" />-
          <input id="StartDate" :type="inputType"
                placeholder="DD" v-model="date[2]"
                @keypress="keyHandling($event, 'Date')" @blur="calculateDate()" />
        </div>
        <div>
          <input :type="inputType"
                placeholder="HH" v-model="time[0]"
                @keypress="keyHandling($event, 'Hour')" @blur="updateTime" />:
          <input :type="inputType"
                placeholder="MM" v-model="time[1]"
                @keypress="keyHandling($event, 'Mins')" @blur="updateTime" />:
          <input :type="inputType"
                placeholder="SS" v-model="time[2]"
                @keypress="keyHandling($event, 'Secs')" @blur="updateTime" />
        </div>
      </div>
    </div>

    <label class="custom-label" :class="{'has-value': dateTime !== null, 'input-error': fieldError}">
      {{label}}
    </label>
    <date-picker :class="{'has-value': dateTime, 'input-error': fieldError}"
                v-model="dateTime" :format="'YYYY-MM-DD (HH:mm:ss)'"
                @open="appendFields" @pick="handlePick" :clearable="false"
                confirm confirm-text="Apply" :editable="false"
                :disabled-date="(date) => date < moment().subtract(1, 'days')"
                @blur="$emit('blur')" />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import moment from 'moment'

export default {
  name: 'DateTime',
  components: { DatePicker },
  data () {
    return {
      dateTime: null,
      date: [null, null, null],
      time: ['00', '00', '00'],
      adoptDOM: null,
      inputType: 'text'
    }
  },
  props: {
    customDateTime: Date,
    label: String,
    fieldError: Boolean
  },
  mounted () {
    this.inputType = this.isDesktop() ? 'text' : 'tel'
    this.dateTime = this.customDateTime
    this.adoptDOM = document.adoptNode(document.getElementById('DateTime'), true)
  },
  watch: {
    dateTime (newVal) {
      this.$emit('updateDateTime', newVal)
    }
  },
  methods: {
    moment,
    handlePick (date) {
      const yyyy = moment(date).format('YYYY')
      const mm = moment(date).format('MM')
      const dd = moment(date).format('DD')

      this.date = [yyyy, mm, dd]
      this.calculateDate()
    },
    populateValues () {
      if (this.dateTime) {
        const dateTime = moment(this.dateTime).format('YYYY-MM-DD HH:mm:ss').split(/[-: ]/)
        this.date = dateTime.slice(0, 3)
        this.time = dateTime.slice(3)
      }
    },
    appendFields () {
      this.populateValues()

      setTimeout(() => {
        document.querySelector(`.mx-calendar-panel-date`).appendChild(this.adoptDOM)
      })
    },
    handleMonth (e, caretPos, elementVal) {
      let maxVal = '12'

      if ((caretPos === 0 && e.key > 1) || (caretPos === 0 && e.key === '1' && elementVal[1] > 2) || (caretPos === 1 && elementVal[0] === '1' && e.key > 2)) {
        e.target.value = maxVal
        this.date[1] = maxVal
        return false
      }
      return true
    },
    handleDate (e, caretPos, elementVal) {
      let date = this.date
      let maxDays = new Date(date[0], date[1], 0).getDate()
      let maxDaysStr = maxDays.toString()

      if ((caretPos === 0 && e.key > maxDaysStr[0]) || (caretPos === 1 && elementVal[0] === maxDaysStr[0] && e.key > maxDaysStr[1])) {
        e.target.value = maxDays
        this.date[2] = maxDays
        return false
      }
      return true
    },
    handleHour (e, caretPos, elementVal) {
      let maxVal = '23'

      if ((caretPos === 0 && e.key > 2) || (caretPos === 0 && e.key === '2' && elementVal[1] > 3) || (caretPos === 1 && elementVal[0] === '2' && e.key > 3)) {
        e.target.value = maxVal
        this.time[0] = maxVal
        return false
      }
      return true
    },
    handleMins (e, caretPos, elementVal, param) {
      let maxVal = '59'

      if ((caretPos === 0 && e.key > 5)) {
        e.target.value = maxVal
        this.time[param] = maxVal
        return false
      }
      return true
    },
    keyHandling (e, format) {
      if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault()
      } else {
        let caretPos = e.target.selectionStart
        let elementVal = e.target.value
        let maxLen = 2
        let proceed = true

        switch (format) {
          case 'Year': maxLen = 4
            break
          case 'Month': proceed = this.handleMonth(e, caretPos, elementVal)
            break
          case 'Date': proceed = this.handleDate(e, caretPos, elementVal)
            break
          case 'Hour': proceed = this.handleHour(e, caretPos, elementVal)
            break
          case 'Mins': proceed = this.handleMins(e, caretPos, elementVal, 1)
            break
          case 'Secs': proceed = this.handleMins(e, caretPos, elementVal, 2)
            break
        }

        if (!proceed) {
          e.preventDefault()
          this.nextField(e, format)
          return
        }

        if (elementVal[caretPos]) {
          e.target.value = elementVal.substr(0, caretPos) + e.key + elementVal.substr(caretPos + 1)
          this.assignVal(e.target.value, format)
          e.preventDefault()
          e.target.setSelectionRange(caretPos + 1, caretPos + 1)
        } else if (elementVal.length >= maxLen) {
          e.preventDefault()
          this.nextField(e, format)
          return
        }

        if (caretPos === maxLen - 1) {
          this.nextField(e, format)
        }
      }
    },
    nextField (e, format) {
      if (format !== 'Secs') {
        let inputs = document.querySelectorAll('.cal-input-fields input')
        let currNode = [...inputs].findIndex(el => e.target.isEqualNode(el))
        let nextElement = inputs[currNode + 1]

        setTimeout(() => {
          nextElement.focus()
          nextElement.setSelectionRange(0, 0)
        })
      }
    },
    assignVal (value, format) {
      let dateIndex = ['Year', 'Month', 'Date'].indexOf(format)
      if (dateIndex !== -1) {
        this.date[dateIndex] = value
      }

      let timeIndex = ['Hour', 'Mins', 'Secs'].indexOf(format)
      if (timeIndex !== -1) {
        this.time[timeIndex] = value
      }
    },
    calculateDate (check) {
      if (check > -1) {
        this.verifyDays(check)
      }

      this.dateTime = new Date(this.date.join('-'))
      this.dateTime.setHours(this.time[0], this.time[1], this.time[2])
    },
    verifyDays () {
      let maxDays = new Date(this.date[0], this.date[1], 0).getDate()

      if (this.date[2] > maxDays) {
        this.date[2] = maxDays
      }
    },
    updateTime () {
      if (this.dateTime) {
        this.calculateDate()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .date-time-field {
    margin-top: 15px;
  }

  .cal-input-fields {
    @include custom-flex(space-between);
    margin: 8px 0;

    > div {
      border-radius: 5px;
      border: 2px solid $grey-outline;
      min-width: 100px;

      input {
        background: $white;
        width: 25px;
        border: none;
        height: 28px;
        font-size: 11px;
        padding: 0 3px;

        &:focus {
          outline: none;
        }
      }
      ::placeholder {
        font-size: 10px;
      }
    }

    /* Chrome */
    input::-webkit-inner-spin-button, input::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }
    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
  }

  @media screen and (max-width: $tablet) {
    b {
      color: $secondary;
      font-size: 13px;
      font-weight: 500;
      margin-top: 8px;
      display: block;
    }

    .cal-input-fields {
      margin: 4px 0 8px;
    }
  }
</style>
